import React, {useContext} from "react";
import {Input, Form, Modal, Row, TimePicker, DatePicker, Button} from "antd";
import {useTranslation} from "react-i18next";
import moment from "moment";
import {ShiftRequestManagementContext} from "../ShiftRequestManagement";
import { ShiftRequestManagementFilterStatus } from "../shiftRequestManagementFilter/shiftRequestManagementFilterStatus/ShiftRequestManagementFilterStatus";

export const ShiftRequestManagementModal = () => {
    const {
        isCreateModalOpen,
        setIsCreateModalOpen,
        selectedShiftRequest,
        handleOnUpdateShiftRequest
    } = useContext(ShiftRequestManagementContext);

    const {t} = useTranslation(["shiftRequest", "common"]);

    return (
        <Modal
            footer={null}
            visible={isCreateModalOpen}
            onCancel={() => setIsCreateModalOpen(false)}
        >
            <Form
                name="shiftRequest"
                layout="vertical"
                onFinish={handleOnUpdateShiftRequest}
                initialValues={
                    selectedShiftRequest && {
                        _id: selectedShiftRequest?._id,
                        shiftDate: moment(selectedShiftRequest?.date ?? new Date()),
                        shiftTime: [
                            moment(
                                selectedShiftRequest?.startTime.substring(
                                    0,
                                    selectedShiftRequest?.startTime.length - 3
                                ),
                                "HH:mm"
                            ),
                            moment(
                                selectedShiftRequest?.endTime.substring(
                                    0,
                                    selectedShiftRequest?.endTime.length - 3
                                ),
                                "HH:mm"
                            )
                        ],
                        courierCount: selectedShiftRequest?.personCount,
                        shiftNote: selectedShiftRequest?.shiftNote,
                        status: selectedShiftRequest?.status
                    }
                }
            >
                <Form.Item
                    name="shiftDate"
                    label={t("shiftDetails.shiftDay", {ns: "shiftRequest"})}
                >
                    <DatePicker format="DD/MM/YYYY" />
                </Form.Item>
                <Form.Item
                    name="shiftTime"
                    label={t("shiftDetails.shiftTime", {ns: "shiftRequest"})}
                >
                    <TimePicker.RangePicker format="HH:mm" minuteStep={15} hourStep={1} />
                </Form.Item>
                <Form.Item
                    name="courierCount"
                    label={t("shiftDetails.courierCount", {ns: "shiftRequest"})}
                >
                    <Input name="courierCount" placeholder="5" type="number" />
                </Form.Item>
                <Form.Item
                    name="shiftNote"
                    label={t("shiftDetails.shiftNote", {ns: "shiftRequest"})}
                >
                    <Input.TextArea
                        rows={4}
                        placeholder={t("shiftDetails.placeholder", {ns: "shiftRequest"})}
                    />
                </Form.Item>
                <Form.Item
                    name="status"
                >
                    <ShiftRequestManagementFilterStatus
                    showAll={false}
                    />
                </Form.Item>
                <Form.Item>
                    <Button type="primary" htmlType="submit">
                        {t("actions.update", {ns: "common"})}
                    </Button>
                </Form.Item>
            </Form>
        </Modal>
    );
};
